import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { mapProps, compose } from 'recompose';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import { Promo } from './Promo';

const enhanced = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
        }),
    ),
    mapProps(({ activeStore, ...props }: any) => ({
        currency: CURRENCIES_ASSOCIATION[activeStore.default_currency],
        ...props,
    })),
)(Promo as any);

export { enhanced as Promo };
